import { useAuth } from '../context/AuthContext';
import { useTeam } from '../context/TeamContext';

/**
 * Hook pour vérifier les permissions basées sur l'équipe sélectionnée
 * Remplace useVisibilityPermissions pour les actions CRUD sur les données d'équipe
 */
export const useTeamPermissions = () => {
  const { currentUser } = useAuth();
  const { selectedTeam } = useTeam();

  /**
   * Vérifie si l'utilisateur a une permission spécifique sur un module
   * @param {string} module - Le module (technicians, oncalls, skills, absences)
   * @param {string} action - L'action (view, add, edit, delete)
   * @returns {boolean}
   */
  const hasPermission = (module, action) => {
    console.log('🔍 Vérification permissions équipe:', { 
      currentUser: currentUser?.email, 
      selectedTeam: selectedTeam?.name, 
      module, 
      action 
    });

    if (!currentUser || !selectedTeam) {
      console.log('❌ Pas d\'utilisateur ou d\'équipe sélectionnée');
      return false;
    }

    // Super Admin peut tout faire
    if (currentUser.role === 'SUPER_ADMIN') {
      console.log('✅ SUPER_ADMIN - permission accordée');
      return true;
    }

    // Admin de l'équipe (principal ou assistant)
    if (selectedTeam.adminUserId === currentUser.id || selectedTeam.assistantAdminUserId === currentUser.id) {
      console.log('✅ Admin de l\'équipe - permission accordée');
      return true;
    }

    // Vérifier les permissions déléguées dans les paramètres de l'équipe
    const permissions = selectedTeam.settings?.permissions?.[module] || { 
      view: true, 
      add: false, 
      edit: false, 
      delete: false 
    };

    const result = permissions[action] || false;
    console.log(result ? '✅ Permission déléguée accordée' : '❌ Permission déléguée refusée', { permissions, action, result });
    
    return result;
  };

  // Fonctions de commodité pour chaque action
  const canAdd = (module) => hasPermission(module, 'add');
  const canEdit = (module) => hasPermission(module, 'edit');
  const canDelete = (module) => hasPermission(module, 'delete');
  const canView = (module) => hasPermission(module, 'view');

  return {
    hasPermission,
    canAdd,
    canEdit,
    canDelete,
    canView,
    currentUser,
    selectedTeam
  };
};

export default useTeamPermissions;
